<template>
  <div class="itw-input-container">
    <slot name="label">
      <span class="caption font-weight-medium" v-if="label">
        {{ label }} <span class="error--text" v-if="required">*</span>
      </span>
    </slot>
    <v-combobox
      v-model="model"
      :prepend-inner-icon="prependInnerIcon"
      :append-icon="appendIcon"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      :search-input.sync="searchInput"
      :loading="loading"
      :readonly="readonly"
      :disabled="disabled"
      :placeholder="placeholder"
      :hide-details="hideDetails"
      :rules="rules"
      :multiple="multiple"
      :small-chips="smallChips"
      :chips="chips"
      :deletable-chips="deletableChips"
      :clearable="clearable"
      :return-object="returnObject"
      :hint="hint"
      :persistent-hint="persistentHint"
      dense
      :class="color === 'white' ? 'custom-field-white' : 'custom-field'"
      solo
      flat
      filled
      @change="$emit('change', $event)"
      @keyup.enter="$emit('enter', $event)"
      @update:search-input="$emit('update:search-input', $event)"
    >
      <template v-slot:no-data v-if="showNoData">
        <slot name="no-data">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="grey--text text--darken-3">
                No results found
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </slot>
      </template>

      <template v-slot:selection="data" v-if="showSelectionSlot">
        <slot
          name="selection"
          :item="data.item"
          :index="data.index"
          :parent="data.parent"
        ></slot>
      </template>

      <template v-slot:item="{ item }" v-if="showItemSlot">
        <slot name="item" :item="item"></slot>
      </template>

      <template v-slot:append v-if="append">
        <slot name="append"></slot>
      </template>

      <template v-slot:prepend-item v-if="prependItem">
        <slot name="prepend-item"></slot>
      </template>
    </v-combobox>
  </div>
</template>

<script>
import hasModel from "@/mixins/hasModel";

export default {
  mixins: [hasModel],
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    itemText: {
      type: String,
      required: false,
      default: "text",
    },
    itemValue: {
      type: String,
      required: false,
      default: "value",
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    loading: {
      type: [Boolean, String],
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
    persistentHint: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    rules: {
      type: Array,
      required: false,
      default: () => [],
    },
    prependInnerIcon: {
      required: false,
      type: String,
      default: undefined,
    },
    appendIcon: {
      required: false,
      type: String,
      default: undefined,
    },
    color: {
      type: String,
      required: false,
      default: "default",
    },
    hint: {
      type: String,
      required: false,
      default: "",
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    smallChips: {
      type: Boolean,
      required: false,
      default: false,
    },
    chips: {
      type: Boolean,
      required: false,
      default: false,
    },
    deletableChips: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    returnObject: {
      type: Boolean,
      required: false,
      default: false,
    },
    showNoData: {
      type: Boolean,
      required: false,
      default: true,
    },
    showSelectionSlot: {
      type: Boolean,
      required: false,
      default: false,
    },
    showItemSlot: {
      type: Boolean,
      required: false,
      default: false,
    },
    append: {
      type: Boolean,
      required: false,
      default: false,
    },
    prependItem: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      searchInput: "",
    };
  },
};
</script>
